import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { Icon } from '@iconify/react';
import axios from 'axios';
import CloseStaff from './CloseStaff';
import CustManCards from './CustManCards';
import { useSelector } from 'react-redux';

const CloseMemSch = () => {
  const [showCloseStaff, setShowCloseStaff] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [schemeDetails, setSchemeDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const apiUrl = process.env.REACT_APP_API_URL;
  const token = useSelector(state => state.auth.token);
  const reduxSchemeID = useSelector(state => state.auth.reduxSchemeID);
  
  const navigate = useNavigate();

  useEffect(() => {
    console.log('Token:', token);
    console.log('reduxSchemeID:', reduxSchemeID);
    fetchSchemeDetails();
  }, [token, reduxSchemeID]);
  
  const fetchSchemeDetails = async () => {
    if (!reduxSchemeID) {
      console.error('reduxSchemeID is undefined');
      return;
    }
    try {
      const response = await axios.get(`${apiUrl}/enrolledScheme/closeuserschemedetails?customerEnrolledSchemeId=${reduxSchemeID}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setSchemeDetails(response.data); 
      setLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSchemeDetails();
  }, []);

  const viewdetailhandleClick = () => {
    navigate('/home/view-detail-scheme');
  };

  const onClickGoBack = () => {
    navigate('/admin/home/viewing-user-profile');
  };

  const handleCloseSchemeClick = () => {
    setShowPopup(true);
  };

  const handleProceedClick = () => {
    setShowPopup(false);
    setShowCloseStaff(true);
  };

  const handleCancelClick = () => {
    setShowPopup(false);
  };

  if (loading) return <p>Loading...</p>;
  if (!schemeDetails) return <p>No scheme details available</p>;

  return (
    <>
      {showCloseStaff ? (
        <CloseStaff />
      ) : (
        <div className="whole-mysave-cont">
          <CustManCards />
          <div className="close-use-out">
            <button className="get-back-out" onClick={onClickGoBack}>
              <Icon icon="iconamoon:arrow-left-2-bold" className="go-back-symbol" />
              Go Back
            </button>
            <div className="member-scheme">
              <div className="maturity-cont">
                <div className="due-cont">
                  <div className="due-filled">
                    <span>{schemeDetails.noOfPaidInstallments}</span>
                    <span>{schemeDetails.totalMonths}</span>
                  </div>
                  <div className="mat-date-cont">
                    <h3>Maturity Date</h3>
                    <h2>{new Date(schemeDetails.maturityDate).toLocaleDateString()}</h2>
                  </div>
                </div>
                <div className="scheme-container">
                  <div className="scheme-detail">
                    <span className="label">Scheme ID</span>
                    <span className="value">{schemeDetails.schemeId}</span>
                  </div>
                  <div className="scheme-detail">
                    <span className="label">Amount</span>
                    <span className="value">₹ {schemeDetails.amount} /-</span>
                  </div>
                  <div className="scheme-detail">
                    <span className="label">Membership No.</span>
                    <span className="value">{schemeDetails.customerId}</span>
                  </div>
                  <div className="scheme-detail">
                    <span className="label">Group Code:</span>
                    <span className="value">{schemeDetails.groupId}</span>
                  </div>
                </div>
                <div className="pay-detail">
                  <h3>Payment Status:</h3>
                  <p>{schemeDetails.paymentStatus}</p>
                </div>
              </div>

              <div className="id-cont">
                <div className="profile-cont">
                  <div className="profile-out-cont">
                    <FontAwesomeIcon icon={faUser} className="profile-icon" />
                  </div>
                  <div className="profile-det">
                    <p>{schemeDetails.fullName}</p>
                    <p>{schemeDetails.alternateMobileNumber}</p>
                    <p>{schemeDetails.gender === 0 ? 'Male' : 'Female'}</p>
                  </div>
                </div>

                <div className="upcoming-due-date">
                  <h3>Upcoming Due Date:</h3>
                  <p>{new Date(schemeDetails.upcomingDueDate).toLocaleDateString()}</p>
                </div>
              </div>
            </div>

            <div className="btn-close-grp">
              <button className="close-btn view-det" onClick={viewdetailhandleClick}>
                View Details
              </button>
              <button className="close-btn close-sch" onClick={handleCloseSchemeClick}>
                Close Scheme
              </button>
            </div>
          </div>

          {showPopup && (
            <div className="popup-overlay">
              <div className="popup-mem-sch">
                <div className="popup-content-mem-sch">
                  <p>
                    Looks like the scheme still has{' '}
                    {schemeDetails.totalMonths - schemeDetails.noOfPaidInstallments} months left
                    to end. Do you want to proceed with foreclosure?
                  </p>
                  <div className="popup-buttons-mem-sch">
                    <button
                      className="popup-btn-mem-sch proceed-btn-mem-sch"
                      onClick={handleProceedClick}
                    >
                      Proceed
                    </button>
                    <button
                      className="popup-btn-mem-sch cancel-btn-mem-sch"
                      onClick={handleCancelClick}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default CloseMemSch;